module.exports = __webpack_public_path__ + "static/media/file-upload-done.4cb7b140.svg";